// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import { CustomAvatar } from '../../../components/custom-avatar';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5),
  borderRadius: 16,
  color: '#FFFFFF',
  backgroundColor: alpha('#FFFFFF', 0.1),
  border: `1px solid ${alpha('#FFFFFF', 0.14)}`,
  boxShadow: '0 8px 24px rgba(7, 43, 63, 0.1)',
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();

  return (
    <StyledRoot>
      <CustomAvatar src="" alt={user?.displayName} name={user?.displayName} />

      <Box sx={{ marginInlineStart: 1.5, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.displayName}
        </Typography>

        <Typography variant="body2" noWrap sx={{ color: alpha('#FFFFFF', 0.62) }}>
          {user?.phoneNumber}
        </Typography>
      </Box>
    </StyledRoot>
  );
}
